<template>
  <div class="page-container">
    <Filter :params="params" @search="searchData" :add="authList.includes('bigScreen:add')" @add="addOTA">
    </Filter>
    <Table :tableData="tableDataList" :total="total" @update="updatePage" select @select="handleSelect">
      <el-table-column prop="name" :label="$t('status.largescreenm.otaLargeScreenName')">
        <template #default="scope">
          <el-badge v-if="scope.row.unbindRobotCount !==0" :value="scope.row.unbindRobotCount" type="error" :max="99" class="item">
            <div style="padding: 4px;"> {{scope.row.name}}</div>
          </el-badge>
          <div v-else style="padding: 4px;"> {{scope.row.name}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="groupCount" :label="$t('status.largescreenm.numberOfGroups')"/>
      <el-table-column prop="robotCount" :label="$t('status.largescreenm.numberOfRobots')"/>
      <el-table-column :label="$t('status.largescreenm.belongingCompany')" prop="createCustomer"></el-table-column>
      <el-table-column :label="$t('status.largescreenm.isDisabled')">
        <template #default="scope">
          <el-switch
            @change="enableChange(scope.row)"
            v-model="scope.row.enable"
            active-text=""
            inactive-text="">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="createByStr" :label="$t('activity.list.creator')"/>
      <el-table-column prop="createTime" :label="$t('activity.list.createTime')"/>
      <el-table-column prop="updateByStr" :label="$t('status.largescreenm.updater')"/>
      <el-table-column prop="updateTime" :label="$t('collect.healthscorelist.updateDate')"/>
      <el-table-column :label="$t('activity.list.operation')" width="150" fixed="right">
        <template #default="scope">
          <el-button v-show="authList.includes('bigScreen:delete')" type="text" style="color: #f56c6c;" size="mini" @click="handleDelete(scope.row)"
            >{{$t('activity.packetjoin.delete')}}</el-button
          >
          <el-button v-show="authList.includes('bigScreen:edit')" type="text" size="mini" @click="handleEdit(scope.row)"
            >{{$t('activity.list.edit')}}</el-button
          >
          <el-button v-show="authList.includes('bigScreen:detail')" type="text" :disabled="!scope.row.enable" size="mini" @click="handleClick(scope.row)"
            >{{$t('status.largescreenm.viewLargeScreen')}}</el-button
          >
        </template>
      </el-table-column>
    </Table>

    <el-dialog
      :title="edit?$t('status.largescreenm.editOtaLargeScreen'): $t('status.largescreenm.addOtaLargeScreen')"
      v-model="dialogFormVisible"
      destroy-on-close
      :modal="true"
      :append-to-body="true"
      width="70%"
    >
      <el-form
        ref="detailformRef"
        class="dialog-form"
        :model="detailform"
        :rules="detailformRules"
        :label-width="curLang == 'zh-CN' ? '120px' : '180px'"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('status.largescreenm.largeScreenName')" prop="name">
              <el-input
                v-model="detailform.name"
                :placeholder="$t('status.largescreenm.largeScreenName')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="edit" :label="$t('status.largescreenm.edgeId')" prop="id">
              <el-input
                disabled="true"
                v-model="detailform.id"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('status.largescreenm.uploadLogo')" prop="logoUrl">
          <el-upload
            :file-list="imageList"
            action="#"
            :limit="1"
            :auto-upload="false"
            name="image"
            list-type="picture-card"
            :on-change="onImageChange"
            :on-remove="onImageRemove"
            :on-preview="onImagePreview"
          >
            <i class="el-icon-plus"></i>
            <template #tip>
              <div class="el-upload__tip">{{$t('activity.detail.imgLimit')}}<span style="color:red;">{{$t('activity.detail.imgSize660')}}</span>
              </div>
            </template>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('status.largescreenm.autoRotationDuration')" prop="scrollInterval">
          <el-input-number style="width:40%" :placeholder="$t('status.largescreenm.autoRotationDescription')" v-model="detailform.scrollInterval" controls-position="right" clearable :min="0" :max="20"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('status.largescreenm.usageDescription')" prop="description">
          <el-input
            :rows="2"
            v-model="detailform.description"
            :placeholder="$t('status.largescreenm.usageDescription')"
            clearable
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <div class='title'>
        <div >{{$t('status.largescreenm.robotConfiguration')}}</div>
        <el-button size="small" type="primary" @click="addGroup">{{$t('status.largescreenm.addGroup')}}</el-button>
      </div>
      <el-table :data="detailform.groupList" max-height="400" min-height="300">
        <el-table-column type="expand">
          <template #default="scope">
            <el-table :data="scope.row.robotList">
              <el-table-column :label="$t('activity.list.serialNo')" type="index" width="120"></el-table-column>
              <el-table-column prop="serialNo" :label="$t('activity.packetjoin.robotCode')" />
              <el-table-column prop="robotName" :label="$t('status.largescreenm.robotName')" />
              <el-table-column prop="power" :label="$t('status.largescreenm.ratedPower')" />
              <el-table-column prop="cabinetId" :label="$t('collect.healthscorelist.ctrlCabCode')" />
              <el-table-column prop="customer" :label="$t('activity.signin.customerName')" />
              <el-table-column prop="source" :label="$t('status.largescreenm.source')" />
              <el-table-column prop="status" :label="$t('points.exchange.status')" >
                <template #default="scope">
                  {{ statusList[scope.row.status] }}
                </template>
              </el-table-column>
              <el-table-column prop="updateTime" :label="$t('collect.healthscorelist.updateTime')" />
            </el-table>
          </template>
           
        </el-table-column>
        <el-table-column :label="$t('activity.list.serialNo')" type="index" width="120"></el-table-column>
        <el-table-column prop="code" :label="$t('status.largescreenm.groupNumber')" />
        <el-table-column prop="name" :label="$t('status.largescreenm.groupName')" />
        <el-table-column prop="robotCount" :label="$t('status.largescreenm.numberOfRobots')">
          <template #default="scope">
            {{ scope.row.robotList?.length }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('status.largescreenm.robotSerialNumber')">
          <template #default="scope">
            {{ scope.row.robotList !== undefined ? scope.row.robotList.map(it=> it.serialNo).toString() : '' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('activity.list.operation')" fixed="right">
          <template #default="scope">
            <el-button size="small" type="text" @click="editGroup(scope.row)">{{$t('status.largescreenm.editGroup')}}</el-button>
            <el-button size="small" type="text" @click="deleteRobotInfo(scope, 0)">{{$t('status.largescreenm.deleteGroup')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template #footer>
        <el-button size="small" type="primary" @click="editSubmit"
          >{{$t('activity.list.confirm')}}</el-button
        >
      </template>
    </el-dialog>

    <el-dialog
      :title="robotEdit ? $t('status.largescreenm.editGroup'): $t('status.largescreenm.addGroup')"
      v-model="dialogAddFormVisible"
      destroy-on-close
      :modal="true"
      :append-to-body="true"
      width="70%"
    >
      <el-form
        ref="detailAddformRef"
        class="dialog-form"
        :model="detailform"
        :rules="detailAddformRules"
      >
        <el-form-item :label="$t('status.largescreenm.groupCategoryName')" prop="groupName">
          <el-input
            v-model="detailform.groupName"
            :placeholder="$t('status.largescreenm.groupCategoryName')"
            clearable
          />
        </el-form-item>
      <!-- </el-form> -->
      <el-button size="small" type="primary" @click="addData">{{$t('status.largescreenm.addNewRow')}}</el-button>
      <el-table :data="detailform.robotList" max-height="480">
        <el-table-column :label="$t('activity.list.serialNo')" type="index" width="120"></el-table-column>
        <el-table-column v-if="edit" prop="source" :label="$t('status.largescreenm.source')" >
          <template #default="scope">
            <el-form-item label="" :prop="`robotList.${scope.$index}.source`" :rules="detailAddformRules.source">
              <el-select v-model="scope.row.source"  clearable :placeholder="$t('status.largescreenm.pleaseSelect')">
                <el-option key="发现" :label="$t('status.largescreenm.discover')" value="发现"></el-option>
                <el-option key="绑定" :label="$t('status.largescreenm.bind')" value="绑定"></el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="serialNo" :label="$t('activity.packetjoin.robotCode')" width="200">
            <template #default="scope">
              <el-form-item label="" :prop="`robotList.${scope.$index}.serialNo`" :rules="detailAddformRules.serialNo">
                <el-select v-model="scope.row.serialNo" clearable @change="(val)=>onRobotChange(val,scope.row)" filterable :placeholder="$t('status.largescreenm.pleaseSelect')">
                  <el-option
                  :disabled="[...currRobotList,...detailform.robotList.map(item => item.serialNo)].includes(item.robotId) "
                  v-for="item in edit ? scope.row.source == '绑定' ? optionsBind : optionsFind : optionsBind"
                  :key="item.robotId"
                  :label="item.robotId"
                  :value="item.robotId">
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
        </el-table-column>
        <el-table-column prop="robotName" :label="$t('status.largescreenm.robotName')" >
          <template #default="scope">
            <el-form-item label="" :prop="`robotList.${scope.$index}.robotName`" :rules="detailAddformRules.robotName">   
              <el-input v-model="scope.row.robotName" :placeholder="$t('status.largescreenm.pleaseEnter')" clearable></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column :label="$t('status.largescreenm.ratedPower')" prop="power">
          <template #default="scope">
            <el-form-item label="" :prop="`robotList.${scope.$index}.power`" :rules="detailAddformRules.power">         
              <el-input v-model="scope.row.power" :placeholder="$t('status.largescreenm.pleaseEnter')" clearable></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="cabinetId" :label="$t('collect.healthscorelist.ctrlCabCode')" />
        <el-table-column prop="customer" :label="$t('activity.signin.customerName')" />
        <el-table-column prop="status" :label="$t('points.exchange.status')" >
            <template #default="scope">
            {{ statusList[scope.row.status] }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('activity.list.operation')">
          <template #default="scope">
            <el-button size="small" type="primary" @click="deleteRobotInfo(scope, 1)">{{$t('activity.packetjoin.delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
      <template #footer>
        <el-button size="small" type="primary" @click="addGroupInfo"
          >{{$t('activity.list.confirm')}}</el-button
        >
      </template>
    </el-dialog>
    <el-image-viewer
      v-if="viewerList?.length"
      :url-list="viewerList"
      :initial-index="viewerIndex"
      :infinite="false"
      :z-index="3000"
      @close="viewerList=[]"
    ></el-image-viewer>
  </div>
  
</template>

<script>
import { request } from "@/utils/request";
import { common } from "../../common/mixin";
// import { ElMessage } from "element-plus";
import { robotStatusMap } from "@/common/constant";
import Table from "@/components/table/index";
import Filter from "@/components/table/filter";
import { otaUpgradeMap } from "@/common/constant"
import { reqGetDetail } from "@/api/robot"
import { reactive, toRefs, computed } from "vue";
import { cloneDeep } from "lodash-es";
import { reqDeleteScreen } from "@/api/robot"
import { ElMessage, ElMessageBox } from "element-plus";
import { useI18n } from 'vue-i18n'
import { getFilePath } from "@/common/utils"
import { useStore } from "vuex"
export default {
  components: {
    Table,
    Filter,
  },
  mixins: [common],
  setup() {
    const store = useStore()
    const { t } = useI18n()
    const state = reactive({
      query: {
        name: null,
        endTime: null,
        startTime: null,
        robotSn: null,
        customer: null,
        otaUpgradeTimeRange:[],
      },
      page: 1,
      size: 10,
      total: 0,
      edit: false,
      robotEdit: false,
      tableDataList: [],
      statusList: robotStatusMap,
      options: [
        {
          id: true,
          name: t('activity.detail.yes'),
        },
        {
          id: false,
          name: t('activity.detail.no'),
        },
      ],
      optionsFind: [],
      optionsBind: [],
      dialogFormVisible: false,
      dialogAddFormVisible: false,
      detailformRef: null,
      detailAddformRef: null,
      detailform: {
        id:'',
        name: '',
        description: '',
        groupName: '',
        groupId: '',
        logoUrl: '',
        scrollInterval: '',
        groupList: [],
        robotList: [{source: 1}],
      },
      groupList: [],
      robotList: [],
      currRobotList: [],
      otaNewVer: '',
      batchDataList: [],
      otaUpgradeMap,
      swimlaneRef: null,
      token: window.localStorage.getItem('token'),
      imageList: [],
      viewerList: [],
      viewerIndex: 0,
      curLang: computed(() => store.state.lang),
      authList: JSON.parse(window.localStorage.getItem('authList'))
    })
    const detailformRules = reactive({
      name: {
        required: true,
        message: t('status.largescreenm.enterLargeScreenName'),
        trigger: 'change'
      },
    })
    const detailAddformRules = reactive({
      groupName: {
        required: true,
        message: t('status.largescreenm.enterGroupName'),
        trigger: 'change'
      },
      source: {
        required: true,
        message: t('status.largescreenm.selectSource'),
        trigger: 'change'
      },
      serialNo: {
        required: true,
        message: t('status.largescreenm.selectRobotCode'),
        trigger: 'change'
      },
      robotName: {
        required: true,
        message: t('status.largescreenm.enterRobotName'),
        trigger: 'change'
      },
      power: {
        required: true,
        message: t('status.largescreenm.enterRatedPower'),
        trigger: 'change'
      },
    })
    const params = reactive([
      {
        key: "name",
        value: "",
        label: t('status.largescreenm.largeScreenName'),
      },
      {
        key: "robotSn",
        value: "",
        label: t('activity.packetjoin.robotCode'),
      },
      {
        key: "customer",
        value: "",
        label: t('status.largescreenm.belongingCompany'),
      },
      {
        type: "Date",
        key: "otaUpgradeTimeRange",
        value: [],
        label: t('collect.healthscorelist.updateDate'),
        options: {
          "type": "datetimerange",
          "format": "YYYY-MM-DD HH:mm:ss",
          "value-format": "YYYY-MM-DD HH:mm:ss",
          "range-separator": t('activity.detail.to'),
          "start-placeholder": t('activity.list.startDate'),
          "end-placeholder": t('activity.list.endDate'),
          "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]
        }
      },
    ])
   
    const onImageChange = (file) => {
      const formData = new FormData();
      formData.append('file', file.raw)
      console.log()
      request("uploadLogo", formData)
        .then((data) => {
          state.detailform.logoUrl = data.filePath
        })
        .catch((error) => {
          console.error(error);
        });
    }
    const onImageRemove = () => {
      state.detailform.logoUrl = ''
    }
    const onImagePreview = (item) => {
      console.log('onImagePreview', item)
      if (item) {
        state.viewerList = state.imageList.map(item => item.url)
        state.viewerIndex = state.viewerList.indexOf(item.url)
      }
    }

    const getData = () => {
      request("getScreenPageList", {
        ...state.query,
        page: state.page,
        size: state.size,
        startTime: state.query?.otaUpgradeTimeRange[0],
        endTime: state.query?.otaUpgradeTimeRange[1],
      })
        .then((data) => {
          state.tableDataList = data.records;
          state.total = data.total;
        })
        .catch((error) => {
          console.error(error);
        });
    }
    const APP_ENV = process.env.APP_ENV
    const handleClick = (row) => {
      const url = APP_ENV == "dev" ? "https://ota.uat.jaka.com" : `${window.location.origin}`
      window.open(`${url}/screen/login?id=${row.id}&token=${state.token}&lan=${state.curLang}`)
    }
    const handleDelete = async(item) =>{
      try {
        await ElMessageBox.confirm(
          t('activity.list.confirmDelete'),
          {
            confirmButtonText: t('activity.list.confirm1'),
            cancelButtonText: t('activity.list.cancel'),
            type: 'warning',
          }
        )
        ElMessage({
          showClose: true,
          type: "success",
          message: t('activity.list.opSuccess')
        })
        await reqDeleteScreen(item.id)
        getData()
      } catch (error) {
        console.error(error)
      }
    }
    const handleEdit = async(item) =>{
      state.edit = true
      try {
        const res = await reqGetDetail(item.id)
        state.dialogFormVisible = true
        state.detailform = res
        state.imageList = res.logoUrl ? [{url: `${getFilePath()}${res.logoUrl}` }] : []
      } catch (error) {
        console.error(error)
      }
    }
    const enableChange = async(val) => {
      request("enableScreen", {
        enable: val.enable,
        screenId: val.id,
      })
        .then((data) => {
          console.log(data)
          getData();
        })
        .catch((error) => {
          console.error(error);
        });
    }
    const searchData = (data) => {
      state.query = data;
      getData();
    }
    const updatePage = (page, size) => {
      state.page = page || 1;
      state.size = size || 10;
      getData();
    }
    const formatStatus = (row) => {
      return robotStatusMap[row.status];
    }
    const handleSelect = (data) => {
      state.batchDataList = data.map((item)=>{
        return item.robotId
      })
    }
    const addOTA = async () => {
      state.edit = false
      state.dialogFormVisible = true
      state.imageList = []
      state.detailform = {
        edgeId:'',
        name: '',
        description: '',
        groupName: '',
        groupList: [],
      }
    }
    const upgradeOTA = async () => {
      state.dialogFormVisible = true
    }

   const onRobotChange = (value,item) => {
    const data = state.optionsBind.filter(it => it.robotId == value)[0]
    item.status = data.status
    item.cabinetId = data.cabinetId
    item.customer = data.customer
    item.id = data.id
    item.serialNo = data.robotId
  }

    const getFindRobotData = async (screenEdgeId) => {
      try {
        const res = await request('getDigScreenRobotList', {
          // size: state.size,
          screenEdgeId: screenEdgeId,
        })
        state.optionsFind = res || []
      } catch (error) {
        console.error(error)
      }
    }

    const getBindRobotData = async () => {
      try {
        const res = await request('getDigScreenRobotList', {
          // size: state.size,
        })
        state.optionsBind = res || []
      } catch (error) {
        console.error(error)
      }
    }

    const addGroup = ()=>{
      state.dialogAddFormVisible = true
      getBindRobotData()
      getCurrRobotList(-1)
      state.edit && getFindRobotData(state.detailform.id)
      state.robotEdit = false
      state.detailform.robotList = []
      state.detailform.groupName = ''
    }
    const editGroup = (row)=>{
      state.detailform.robotList = cloneDeep(row.robotList)
      state.dialogAddFormVisible = true
      getCurrRobotList(row.id)
      state.detailform.groupName = row.name
      state.detailform.groupId = row.id
      state.edit && getFindRobotData(state.detailform.id)
      state.robotEdit = true
      getBindRobotData()
    }

    const getCurrRobotList = (id) =>{
      state.currRobotList = []
      state.detailform.groupList && state.detailform.groupList.map(item=>{
        if(id !== item.id){
          item.robotList && item.robotList.map(it=>{
            state.currRobotList.push(it.serialNo)
          })
        }
      })
      state.currRobotList = [...new Set(state.currRobotList)]
    }

    const addData = ()=>{
      const data = [{
        status:'',
        cabinetId:'',
        customer:'',
        robotId:'',
        source: ''
      }]
      state.detailform.robotList = [...state.detailform.robotList || [],...data]
    }

    const deleteRobotInfo  = (scope, type)=>{
      type ? state.detailform.robotList.splice(scope.$index,1) : state.detailform.groupList.splice(scope.$index,1)
    }

    const addGroupInfo = async()=>{
      state.detailAddformRef && (await state.detailAddformRef.validate())
      state.detailform.robotList.map(item=>{
        item.robotId = item.id
        item.source = state.edit ? item.source : '绑定'
      })
      const data = [{
        name: state.detailform.groupName,
        robotList: state.detailform.robotList
      }]
      if(state.robotEdit){
        state.detailform.groupList.map(item=>{
          if(item.id == state.detailform.groupId){
            item.name = state.detailform.groupName,
            item.robotList = state.detailform.robotList
          }
        })
      }else{
        state.detailform.groupList = [...state.detailform.groupList || [],...data,]
      }
      state.dialogAddFormVisible = false
    }

    const editSubmit = async()=>{
      state.detailformRef && (await state.detailformRef.validate())
      // try {
      //   await reqAddOrUpdateScreen(state.detailform)
      //   state.dialogFormVisible = false
      // } catch (error) {
      //   console.error(error)
      // }
      try {
        await request('addOrUpdateScreen', state.detailform)
        state.dialogFormVisible = false
        getData()
      } catch (error) {
        console.error(error)
      }
    }
    getData()
    return {
      ...toRefs(state),
      detailformRules,
      detailAddformRules,
      params,
      handleClick,
      handleDelete,
      handleEdit,
      searchData,
      updatePage,
      formatStatus,
      handleSelect,
      addOTA,
      upgradeOTA,
      addGroup,
      editGroup,
      addGroupInfo,
      editSubmit,
      addData,
      deleteRobotInfo,
      onRobotChange,
      enableChange,
      onImageChange,
      onImageRemove,
      onImagePreview
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.item {
  margin-top: 10px;
  margin-right: 40px;
}
.title {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 700;
}
// ::deep .el-table td, .el-table th.is-leaf {
//     border-bottom: var(--el-table-border);
//     background: #9e9e9e14;
//     text-align: center;
// }
</style>